import React, { useState, useEffect, useMemo } from "react";
import NavigationMenu from "../Navigation/NavigationMenu";
import axios from "axios";
import Select from "react-select";
import { Link } from "react-router-dom";
import {
  Input,
  ChakraProvider,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  // Select,
  Textarea,
  Table,
  Thead,
  Icon,
  Tbody,
  Tr,
  Th,
  Td,
  FormLabel,
  Flex,
  Image,
  FormControl,
  Box,
  Stack,
  Text,
} from "@chakra-ui/react";

import { Select as ChakraSelect } from "@chakra-ui/react";

import { DatePicker } from "antd";
import "./AddLeaveRequest.css";

import { ChevronDownIcon, ChevronUpIcon, AddIcon } from "@chakra-ui/icons";

// import { SearchIcon, ViewIcon, EditIcon, DeleteIcon } from "@chakra-ui/icons";

const AddLeaveRequest = () => {
  const handleSearch = () => {
    // Define what happens when you search
    console.log("Searching...");
  };

  const [isOpen, setIsOpen] = useState(false);
  const [leaveCategory, setLeaveCategory] = useState("");
  const [leaveReason, setLeaveReason] = useState("");
  const [staffID, setStaffID] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterStatusname, setFilterStatusName] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [leaveState, setLeaveState] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [leaveRecords, setLeaveRecords] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [staff, setStaff] = useState([]);
  const [searchDate, setSearchDate] = useState([]);
  const [searchToDate, setSearchToDate] = useState([]);
  const [jumpPage, setJumpPage] = useState("");

  const [leaveRequest, setLeaveRequests] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);

  const [leaveSummary, setLeaveSummary] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [activeQueryMode, setActiveQueryMode] = useState("default");
  const [activeDateFilter, setActiveDateFilter] = useState("");

  const [leaveCounts, setLeaveCounts] = useState({
    yesterday: 0,
    today: 0,
    tomorrow: 0,
    absent: 0,
  });

  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    const fetchLeaveCounts = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_API || `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}`}/Leave/leave-counts/`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        setLeaveCounts(response.data);
      } catch (error) {
        console.error("Error fetching leave counts:", error);
      }
    };

    fetchLeaveCounts();
  }, []);

  const leaveCategories = [
    "Annual Leave",
    "Sick Leave",
    "Maternity Leave",
    "Monthly Off",
    "Casual Leave",
    "Privilege Leave",
    "Absent",
  ];
  const leaveStates = ["Pending", "Approved", "Rejected"];

  const handleAddLeaveRecord = async () => {
    const newLeaveRecord = {
      staffID,
      leaveCategory,
      leaveReason,
      fromDate,
      toDate,
      leaveState,
    };

    console.log("Staff ID: ", staffID);
    console.log("Leave Category: ", leaveCategory);
    console.log("Leave Reason: ", leaveReason);
    console.log("Leave Reason: ", fromDate);
    console.log("Leave Reason: ", toDate);
    console.log("Leave Reason: ", leaveState);

    const formData = {
      staff_id: selectedStaff,
      start_date: fromDate,
      end_date: toDate,
      leave_type: leaveCategory,
      reason: leaveReason,
      status: leaveState,
    };

    const accessToken = localStorage.getItem("access_token");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_API || `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}`}/Leave/api/save-leave-request/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200) {
        console.log("Leave request submitted:", response.data);
        alert("Saved");
        fetchLeaveRequests();
       
        setLeaveCategory("");
        setLeaveReason("");
        setFromDate("");
        setToDate("");
        setLeaveState("");
        setIsOpen(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }

    if (editIndex !== null) {
      const updatedLeaveRecords = [...leaveRecords];
      updatedLeaveRecords[editIndex] = newLeaveRecord;
      setLeaveRecords(updatedLeaveRecords);
      setEditIndex(null);
    } else {
      setLeaveRecords([...leaveRecords, newLeaveRecord]);
    }

    // Clear input fields after adding or editing leave record
    setLeaveCategory("");
    setLeaveReason("");
    setFromDate("");
    setToDate("");
    setLeaveState("");
    setIsOpen(false);
  };

  const token = localStorage.getItem("access_token");

  const fetchLeaveRequests = async (page = 1) => {
    const accessToken = localStorage.getItem("access_token");
    setActiveQueryMode("default");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_API || `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}`}/Leave/api/leaves/`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: { page },
        }
      );
      
      const data = response.data.results ? response.data.results : response.data;
      if (response.data.count !== undefined) {
        setTotalCount(response.data.count);
      }
      
      const mappedData = data.map(item => ({
        ...item,
        user: item.user || item.user__id,
        staff_name: item.staff_name || item.user__fname,
        staff_lname: item.staff_lname || item.user__lname,
        staff_img: item.staff_img || item.user__image,
      }));
      setLeaveRequests(mappedData);
      console.warn("Mapped Leave Requests:", mappedData);
    } catch (error) {
      console.error("Error fetching leave requests:", error);
    }
  };

  const fetchUserData = async (staffID) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}/HumanResource/getUserFromStaffID/${staffID}/`
      );
      setEmployee(response.data);
      console.log("Fetched user data:", response.data);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    fetchLeaveRequests();
    fetchData();
  }, []);

  const [expandedRowSearchEmployee, setExpandedRowSearchEmployee] =
    useState(null);

  const toggleExpandSearchEmployee = (id) => {
    setExpandedRowSearchEmployee(expandedRowSearchEmployee === id ? null : id);
  };

  const fetchData = async () => {
    try {
      if (token) {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_API || `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}`}/HumanResource/StaffList/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setStaff(response.data);
      } else {
        console.error("Access token not found");
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };

  const fetchfilteredLeaveRequests = async (page = 1) => {
    const accessToken = localStorage.getItem("access_token");
    console.log("Date Search: ", searchDate);
    setActiveQueryMode("search");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}/Leave/api/searched_date/`,
        {
          params: {
            search_date: searchDate,
            search_to_date: searchToDate,

            status: filterStatus,
            filter_status_name: filterStatusname,
            page: page,
          },
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      
      const data = response.data.results ? response.data.results : response.data;
      if (response.data.count !== undefined) {
        setTotalCount(response.data.count);
      }
      
      const mappedData = data.map(item => ({
        ...item,
        user: item.user || item.user__id,
        staff_name: item.staff_name || item.user__fname,
        staff_lname: item.staff_lname || item.user__lname,
        staff_img: item.staff_img || item.user__image,
      }));
      setLeaveRequests(mappedData);
    } catch (error) {
      console.error("Error fetching leave requests:", error);
    }
  };

  const handleDateFilter = async (date, page = 1) => {
    const token = localStorage.getItem("access_token");
    setActiveQueryMode("dateFilter");
    setActiveDateFilter(date);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}/Leave/api/Filtered_leave_requests_by_date_view/${date}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { page: page },
        }
      );
      console.log("Leave Requests: ", response.data);
      
      const data = response.data.results ? response.data.results : response.data;
      if (response.data.count !== undefined) {
        setTotalCount(response.data.count);
      }
      
      const mappedData = data.map(item => ({
        ...item,
        user: item.user || item.user__id,
        staff_name: item.staff_name || item.user__fname,
        staff_lname: item.staff_lname || item.user__lname,
        staff_img: item.staff_img || item.user__image,
      }));
      setLeaveRequests(mappedData);
      // Handle the response data as needed, e.g., set it to state
    } catch (error) {
      console.error("Error fetching leave requests:", error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    if (activeQueryMode === "search") {
      fetchfilteredLeaveRequests(newPage);
    } else if (activeQueryMode === "dateFilter") {
      handleDateFilter(activeDateFilter, newPage);
    } else {
      fetchLeaveRequests(newPage);
    }
  };

  const staffOptions = staff.map((category) => ({
    value: category.staff_id,
    label: `${category.fname} ${category.lname} - ${category.staff_id}`,
  }));

  const handleStaffChange = (selectedOption) => {
    // Assuming you are making an API call here or setting the state to be sent to backend
    const staffId = selectedOption ? selectedOption.value : null;
    console.log("Selected Staff ID:", staffId);
    setSelectedStaff(staffId);
    // Send staffId to the backend
  };

  const selectedStaffOption = staffOptions.find(
    (option) => option.value === selectedStaff
  );

  const staffSearchOptions = staff.map((category) => ({
    value: category.staff_id,
    label: `${category.fname} ${category.lname} - ${category.staff_id}`,
  }));

  const handleSearchStaffChange = (selectedOption) => {
    const staffId = selectedOption ? selectedOption.value : null;
    console.log("Selected Staff ID:", staffId);
    setFilterStatusName(staffId);
    // Send staffId to the backend
  };

  const selectedSearchStaffOption = staffSearchOptions.find(
    (option) => option.value === filterStatusname
  );

  return (
    <>
      <NavigationMenu />

      <ChakraProvider>
        <div className="leaveRequestWrapper">
          <div className="container-fluid">
            {/* ***********************************  Search Leave Status *********************** */}

            <div className="row">
              <div className="col-12 col-md-4 col-lg-4">
                <div className="leaveRequestHeading">
                  <h1 style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                    View Leave Request
                  </h1>
                  <>
                    <Button
                      style={{ marginRight: "10px" }}
                      colorScheme="blue"
                      leftIcon={<AddIcon />}
                      backgroundColor={"#338687"}
                      onClick={() => setIsOpen(true)}
                    >
                      Add Leave Request
                    </Button>{" "}
                    {/* <Link to="/leaveSummaryPage">
                      <Button colorScheme="blue" backgroundColor="#338687">
                        Leave Summary
                      </Button>
                    </Link> */}
                    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
                      <ModalOverlay />
                      <ModalContent>
                        <ModalHeader>Add Leave Request</ModalHeader>
                        <ModalCloseButton />

                        <ModalBody>
                          <Stack spacing={4}>
                            <FormControl id="staff_id">
                              <FormLabel>Employee ID</FormLabel>
                              <Select
                                placeholder="Select Staff"
                                value={selectedStaffOption}
                                name="staff_id"
                                onChange={handleStaffChange}
                                options={staffOptions}
                                isSearchable
                              />
                            </FormControl>
                            <FormControl id="leaveCategory">
                              <FormLabel>Leave Category</FormLabel>
                              <ChakraSelect
                                placeholder="Select Leave Category"
                                value={leaveCategory}
                                onChange={(e) =>
                                  setLeaveCategory(e.target.value)
                                }
                              >
                                {leaveCategories.map((category, index) => (
                                  <option key={index} value={category}>
                                    {category}
                                  </option>
                                ))}
                              </ChakraSelect>
                            </FormControl>
                            <FormControl id="leaveReason">
                              <FormLabel>Leave Reason</FormLabel>
                              <Textarea
                                placeholder="Leave Reason"
                                value={leaveReason}
                                onChange={(e) => setLeaveReason(e.target.value)}
                              />
                            </FormControl>
                            <FormControl id="fromDate">
                              <FormLabel>From Date</FormLabel>
                              <Input
                                type="date"
                                placeholder="From Date"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                              />
                            </FormControl>
                            <FormControl id="toDate">
                              <FormLabel>To Date</FormLabel>
                              <Input
                                type="date"
                                placeholder="To Date"
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                              />
                            </FormControl>
                            <FormControl id="leaveState">
                              <FormLabel>Leave Status</FormLabel>
                              <ChakraSelect
                                placeholder="Select Leave Status"
                                value={leaveState}
                                onChange={(e) => setLeaveState(e.target.value)}
                              >
                                {leaveStates.map((state, index) => (
                                  <option key={index} value={state}>
                                    {state}
                                  </option>
                                ))}
                              </ChakraSelect>
                            </FormControl>
                          </Stack>
                        </ModalBody>
                        {/* <ModalBody>
                          <label htmlFor="leaveCategory">Employee ID</label>
                          <Select
                            id="staff_id"
                            placeholder="Select Staff"
                            value={selectedStaffOption}
                            name="staff_id"
                            onChange={handleStaffChange}
                            options={staffOptions}
                            isSearchable
                          />
                          <label htmlFor="leaveCategory">Leave Category</label>
                          <ChakraSelect
                            id="leaveCategory"
                            placeholder="Select Leave Category"
                            value={leaveCategory}
                            onChange={(e) => setLeaveCategory(e.target.value)}
                          >
                            {leaveCategories.map((category, index) => (
                              <option key={index} value={category}>
                                {category}
                              </option>
                            ))}
                          </ChakraSelect>
                          <label htmlFor="leaveReason">Leave Reason</label>
                          <Textarea
                            id="leaveReason"
                            placeholder="Leave Reason"
                            value={leaveReason}
                            onChange={(e) => setLeaveReason(e.target.value)}
                          />
                          <label htmlFor="fromDate">From Date</label>
                          <Input
                            id="fromDate"
                            type="date"
                            placeholder="From Date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                          />
                          <label htmlFor="toDate">To Date</label>
                          <Input
                            id="toDate"
                            type="date"
                            placeholder="To Date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                          />
                          <label htmlFor="leaveState">Leave Status</label>
                          <ChakraSelect
                            id="leaveState"
                            placeholder="Select Leave Status"
                            value={leaveState}
                            onChange={(e) => setLeaveState(e.target.value)}
                          >
                            {leaveStates.map((state, index) => (
                              <option key={index} value={state}>
                                {state}
                              </option>
                            ))}
                          </ChakraSelect>
                        </ModalBody> */}
                        <ModalFooter>
                          <Button
                            colorScheme="blue"
                            mr={3}
                            onClick={() => setIsOpen(false)}
                          >
                            Close
                          </Button>
                          <Button
                            colorScheme="green"
                            onClick={handleAddLeaveRecord}
                          >
                            Save
                          </Button>
                        </ModalFooter>
                      </ModalContent>
                    </Modal>
                  </>
                </div>
              </div>

              <div className="col-12 col-md-4 col-lg-8">
                <div className="col-12 col-md-12 col-lg-12">
                  <Button
                    colorScheme="blue"
                    my={"2"}
                    mx={"4"}
                    width={"20%"}
                    onClick={() => handleDateFilter("Yesterday")}
                  >
                    Yesterday - {leaveCounts.yesterday}
                  </Button>
                  <Button
                    colorScheme="blue"
                    my={"2"}
                    mx={"4"}
                    width={"20%"}
                    onClick={() => handleDateFilter("Today")}
                  >
                    Today - {leaveCounts.today}
                  </Button>
                  <Button
                    colorScheme="blue"
                    my={"2"}
                    mx={"4"}
                    width={"20%"}
                    onClick={() => handleDateFilter("Tomorrow")}
                  >
                    Tomorrow - {leaveCounts.tomorrow}
                  </Button>

                  <Button
                    colorScheme="blue"
                    my={"2"}
                    mx={"4"}
                    width={"20%"}
                    onClick={() => handleDateFilter("Absent")}
                  >
                    Absent - {leaveCounts.absent}
                  </Button>
                </div>
              </div>

              <div className="col-12 col-md-12 col-lg-12">
                <div className="row">
                  <div className="col-12 col-md-2 col-lg-2">
                    <FormControl className="searchEmployeeFormGroup">
                      <FormLabel htmlFor="working_depts">Employee</FormLabel>

                      <Select
                        id="staff_id"
                        placeholder="Select Staff"
                        value={selectedSearchStaffOption}
                        name="staff_id"
                        onChange={handleSearchStaffChange}
                        options={staffSearchOptions}
                        isSearchable
                      />
                    </FormControl>
                  </div>

                  <div className="col-12 col-md-2 col-lg-2">
                    <FormControl className="searchEmployeeFormGroup">
                      <FormLabel htmlFor="working_depts">
                        Leave Status
                      </FormLabel>
                      <ChakraSelect
                        placeholder="Select option"
                        value={filterStatus}
                        onChange={(e) => setFilterStatus(e.target.value)}
                      >
                        <option value="Pending">Pending</option>
                        <option value="Approved">Approved</option>
                        <option value="Not Approved">Not Approved</option>
                      </ChakraSelect>
                    </FormControl>
                  </div>

                  <div className="col-12 col-md-2 col-lg-2">
                    <FormControl className="searchEmployeeFormGroup">
                      <FormLabel htmlFor="employee_id">From Date</FormLabel>
                      <input
                        id="date_of_joining"
                        style={{ width: "100%" }}
                        format="YYYY-MM-DD"
                        name="leave_date"
                        type="date"
                        className="leaveDateStyling"
                        value={searchDate || null}
                        onChange={(e) => setSearchDate(e.target.value)}
                      />
                    </FormControl>
                  </div>

                  <div className="col-12 col-md-2 col-lg-2">
                    <FormControl className="searchEmployeeFormGroup">
                      <FormLabel htmlFor="employee_id">To Date</FormLabel>
                      <input
                        id="date_of_joining"
                        style={{ width: "100%" }}
                        format="YYYY-MM-DD"
                        name="leave_date"
                        type="date"
                        className="leaveDateStyling"
                        value={searchToDate || null}
                        onChange={(e) => setSearchToDate(e.target.value)}
                      />
                    </FormControl>
                  </div>

                  <div className="col-12 col-md-2 col-lg-2">
                    <Button
                      colorScheme="blue"
                      onClick={fetchfilteredLeaveRequests}
                      className="leaveDateBtn"
                    >
                      Search Leave
                    </Button>
                  </div>

                  <div className="col-12 col-md-2 col-lg-2"></div>
                </div>
              </div>

              {/* ***********************************  Show Leave Status *********************** */}
              <div className="col-12 col-md-12 col-lg-12">
                <div className="viewLeaveRequestTable">
                  {useMemo(() => (
                  <Box overflowX={"auto"}>
                    <Table variant="simple" className="leaveRequestTableFormat">
                      <Thead>
                        <Tr>
                          <Th width={"10%"}>Leave ID</Th>
                          <Th width={"20%"}>Name</Th>
                          <Th width={"15%"}>Leave Type</Th>
                          <Th width={"15%"}> From Date</Th>
                          <Th width={"15%"}>To Date</Th>
                          <Th width={"15%"}>Status</Th>
                          <Th width={"5%"}>Action</Th>
                          <Th width={"5%"}></Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {leaveRequest.map((employee) => (
                          <React.Fragment key={employee.id}>
                            <Tr
                              onClick={() =>
                                toggleExpandSearchEmployee(employee.id)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <Td>{employee.id}</Td>

                              <Td>
                                <Flex align="center">
                                  <Image
                                    src={`${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}${employee.staff_img}`}
                                    alt={employee.staff_name}
                                    boxSize="30px"
                                    mr="10px"
                                    borderRadius="50%"
                                  />
                                  {employee.staff_name} {employee.staff_lname}
                                </Flex>
                              </Td>
                              <Td>{employee.leave_type}</Td>
                              <Td>{employee.start_date}</Td>
                              <Td>{employee.end_date}</Td>
                              <Td>{employee.status}</Td>
                              <Td>
                                <Link
                                  to="/leavesummary"
                                  state={{ user_id: employee.user || employee.staff_id || employee.user__id }}
                                >
                                  <Button>Leave Summary</Button>
                                </Link>
                              </Td>
                              <Td>
                                {expandedRowSearchEmployee === employee.id ? (
                                  <Icon as={ChevronUpIcon} />
                                ) : (
                                  <Icon as={ChevronDownIcon} />
                                )}
                              </Td>
                            </Tr>
                            {expandedRowSearchEmployee === employee.id && (
                              <Tr>
                                <Td colSpan={7}>
                                  <h3 className="viewTableLeaveReason">
                                    Leave Reason{" "}
                                  </h3>
                                  <p>{employee.reason}</p>
                                </Td>
                              </Tr>
                            )}
                          </React.Fragment>
                        ))}
                      </Tbody>
                    </Table>
                  </Box>
                  ), [leaveRequest, expandedRowSearchEmployee])}
                  <Flex justifyContent="space-between" alignItems="center" mt={4} p={2}>
                    <Button
                      onClick={() => handlePageChange(currentPage - 1)}
                      isDisabled={currentPage === 1}
                      colorScheme="blue"
                      size="sm"
                    >
                      Previous
                    </Button>
                    <Flex alignItems="center">
                      <Text mr={3}>
                        Page {currentPage} of {Math.ceil(totalCount / 100) || 1} ({totalCount} total)
                      </Text>
                      <Text mr={2} fontSize="sm">Jump to:</Text>
                      <Input
                        type="number"
                        width="70px"
                        size="sm"
                        mr={2}
                        placeholder="Page"
                        value={jumpPage}
                        onChange={(e) => setJumpPage(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            const page = parseInt(jumpPage);
                            const maxPage = Math.ceil(totalCount / 100) || 1;
                            if (page >= 1 && page <= maxPage) {
                              handlePageChange(page);
                              setJumpPage('');
                            }
                          }
                        }}
                      />
                      <Button
                        size="sm"
                        onClick={() => {
                          const page = parseInt(jumpPage);
                          const maxPage = Math.ceil(totalCount / 100) || 1;
                          if (page >= 1 && page <= maxPage) {
                            handlePageChange(page);
                            setJumpPage('');
                          }
                        }}
                        colorScheme="teal"
                      >
                        Go
                      </Button>
                    </Flex>
                    <Button
                      onClick={() => handlePageChange(currentPage + 1)}
                      isDisabled={currentPage >= Math.ceil(totalCount / 100)}
                      colorScheme="blue"
                      size="sm"
                    >
                      Next
                    </Button>
                  </Flex>
                </div>
              </div>

              {/* <div>
                <h2>Leave Summary</h2>
                <table border="1">
                  <thead>
                    <tr>
                      <th>Employee</th>
                      <th>Total Leaves Taken</th>
                    </tr>
                  </thead>
                  <tbody>
                    {leaveSummary.map((leave, index) => (
                      <tr key={index}>
                        <td>{leave.user}</td>
                        <td>{leave.total_leaves}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div> */}
            </div>
          </div>
        </div>
      </ChakraProvider>
    </>
  );
};

export default AddLeaveRequest;